import { PATH_COLORS, TRUE_PATH_COLORS } from '@lib/constants';
import { get } from 'svelte/store';
import { toolMode } from './state';
export const undo = (paths) => {
    console.debug('Undo');
    const _paths = get(paths);
    _paths.pop();
    paths.set(_paths);
};
// TODO Remove
export const getColor = (type, truePathColor = false) => {
    return truePathColor
        ? TRUE_PATH_COLORS[type]
        : PATH_COLORS[type];
};
export const setMode = (() => {
    let lastTool = get(toolMode);
    // 'last' sets the mode to the last paint tool
    return (mode) => {
        console.debug('Set mode', mode, 'last:', lastTool);
        const tmp = get(toolMode);
        mode === 'last'
            ? toolMode.set(lastTool)
            : toolMode.set(mode);
        lastTool = isPaintMode(tmp) ? tmp : lastTool;
    };
})();
export const isPaintMode = (mode) => mode === 'autoLine' || mode === 'brush' || mode === 'fill';
// TODO Remove?
export const isDrawingMode = (mode) => mode === 'autoLine' || mode === 'brush';
